export enum PartnerRoleStatus {
  KAS = 'KAS',
  KPN = 'KPN',
  PIE = 'PIE',
  SAB = 'SAB',
}
